import React, { useState } from 'react';
import { AutoComplete, Avatar, Input, Layout, Menu, MenuProps, Space } from 'antd';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { SearchOutlined } from '@ant-design/icons';
import SubMenu from 'antd/es/menu/SubMenu';
import { useAuth } from '../../hooks/useAuth';

const { Header: AntdHeader } = Layout;



const items2: MenuProps['items'] = [{
  label: 'Admin',
  key: 'main',
  icon: <Avatar style={{ color: 'orange' }}>A</Avatar>,
  children: [
    //   {
    //   label: 'ดูข้อมูลส่วนตัว',
    //   key: 'profile',
    // },
    {
      label: 'เปลี่ยนรหัสผ่าน',
      key: 'admin/change_password'
    },
    {
      label: 'ออกจากระบบ',
      key: 'logout'
    }]
}]


const mockVal = (str: string, repeat = 1) => ({
  value: str.repeat(repeat),
});

const Header: React.FC = () => {

  const auth: any = useAuth();
  const navigate = useNavigate();
  const [value, setValue] = useState('');
  const [options, setOptions] = useState<{ value: string }[]>([]);
  const [anotherOptions, setAnotherOptions] = useState<{ value: string }[]>([]);

  const onClick = async (e: any) => {
    if (e.key == 'logout') {
      await auth.logout();
    } else {
      navigate(e.key)
    }

  }



  const getPanelValue = (searchText: string) =>
    !searchText ? [] : [mockVal(searchText), mockVal(searchText, 2), mockVal(searchText, 3)];

  const onSelect = (data: string) => {
    console.log('onSelect', data);
  };

  const onChange = (data: string) => {
    setValue(data);
  };

  return (
    <AntdHeader style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
      <div className="demo-logo" />

      {/* <Space.Compact size={'middle'}
        style={{ justifyContent: 'flex-end' }}
      >
        <AutoComplete
          options={options}
          style={{ width: 200 }}
          onSelect={onSelect}
          onSearch={(text) => setOptions(getPanelValue(text))}
          placeholder="Search for people"
        />
      </Space.Compact> */}
      <Menu
        onClick={onClick}
        theme="dark"
        mode="horizontal"
        defaultSelectedKeys={['2']}
        items={items2}
        disabledOverflow
        style={{ justifyContent: 'flex-end' }}
      >

      </Menu>
    </AntdHeader>
  );
};

export default Header;